var supara_token = "";
let language_code = window.Shopify.locale;

function profileOnLoad(customer_id, cus_phone, lang_code=false, avatar = false) {
  fetch("https://apishopify.gqsize.com/supara/onload_avatar", {
    method: "POST",
    dataType: "json",
    body: JSON.stringify({
      avatar_data: avatar,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status == "success") {
        document.getElementById("profilePic").src = data.avatar;
        document.getElementById("tabAvatar").src = data.avatar;
      }
      if (data.status == "fail") {
        document.getElementById("profilePic").src =
          "https://cdn.shopify.com/s/files/1/0631/7755/6173/files/Default-Avatar.jpg?v=1715157089";
        document.getElementById("tabAvatar").src =
          "https://cdn.shopify.com/s/files/1/0631/7755/6173/files/Default-Avatar.jpg?v=1715157089";
      }
    })
    .catch((error) => console.log("error", error));

  var settings = {
    url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/auth/token",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      api_key: "98931F7B-B67D-492C-96F1-A50D66C4DA1B",
      client: "magenest",
    }),
  };

  $.ajax(settings).done(function (response) {
    supara_token = response.data.token;
    var ajax_customer = {
      url:
        "https://api.backend.gw.t.int.suparagroup.com/gq-connect/magenest/customers/get?mobile=" +
        parseInt(cus_phone) +
        "&source=INSTORE",
      method: "GET",
      timeout: 0,
      headers: {
        Authorization: "Bearer " + response.data.token,
      },
    };

    $.ajax(ajax_customer).done(function (cus) {
      document.getElementById("member_id").innerText = 'Member ID: ' + cus.data.member_no;
    });
  });
}

function stickyProfile() {
  var header = document.getElementById("myProfileHeader");
  var sticky = header.offsetTop;
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

$(document).ready(function () {
  var readURL = function (input) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        $(".profile-pic").attr("src", e.target.result);
      };

      reader.readAsDataURL(input.files[0]);
    }
  };

  $(".file-upload").on("change", function () {
    readURL(this);
  });

  $(".upload-button").on("click", function () {
    $(".file-upload").click();
  });

  const myProvince = document.getElementById("myProvince");
  const myDistrict = document.getElementById("myDistrict");
  const mySubdistrict = document.getElementById("mySubdistrict");
  const provinceSearchInput = document.getElementById("provinceSearchInput");
  const districtSearchInput = document.getElementById("districtSearchInput");
  const subdistrictSearchInput = document.getElementById(
    "subdistrictSearchInput"
  );
  const provinceSelect = document.getElementById("provinceSelect");
  const districtSelect = document.getElementById("districtSelect");
  const subdistrictSelect = document.getElementById("subdistrictSelect");
  var overlay = document.getElementById("overlay");

  function clearFilter(className) {
    const options = document.getElementsByClassName(className);

    for (const option of options) {
      option.style.display = "block";
    }
  }

  provinceSearchInput.addEventListener("input", function () {
    const query = provinceSearchInput.value.toLowerCase();
    const options = provinceSelect.getElementsByClassName("province-option");

    for (const option of options) {
      const optionText = option.textContent.toLowerCase();
      if (optionText.indexOf(query) === -1) {
        option.style.display = "none";
      } else {
        option.style.display = "block";
      }
    }
  });
  districtSearchInput.addEventListener("input", function () {
    const query = districtSearchInput.value.toLowerCase();
    const options = districtSelect.getElementsByClassName("district-option");

    for (const option of options) {
      const optionText = option.textContent.toLowerCase();
      if (optionText.indexOf(query) === -1) {
        option.style.display = "none";
      } else {
        option.style.display = "block";
      }
    }
  });
  subdistrictSearchInput.addEventListener("input", function () {
    const query = subdistrictSearchInput.value.toLowerCase();
    const options = subdistrictSelect.getElementsByClassName("subdistrict-option");

    for (const option of options) {
      const optionText = option.textContent.toLowerCase();
      if (optionText.indexOf(query) === -1) {
        option.style.display = "none";
      } else {
        option.style.display = "block";
      }
    }
  });

  // Show dropdown when input is focused
  myProvince.addEventListener("focus", function () {
    provinceSelect.classList.add("active");
    overlay.classList.remove("hidden");
  });

  myDistrict.addEventListener("focus", function () {
    districtSelect.classList.add("active");
    overlay.classList.remove("hidden");
  });

  mySubdistrict.addEventListener("focus", function () {
    subdistrictSelect.classList.add("active");
    overlay.classList.remove("hidden");
  });

  const closeModal = function () {
    overlay.classList.add("hidden");
    provinceSelect.classList.remove("active");
    districtSelect.classList.remove("active");
    subdistrictSelect.classList.remove("active");
  };
  overlay.addEventListener("click", closeModal);

  // Set selected option when option is clicked
  provinceSelect.addEventListener("click", function (e) {
    const option = e.target.closest(".province-option");
    if (option) {
      if (myProvince.textContent != option.dataset.value) {
        myProvince.textContent = option.dataset.value;
        myProvince.value = option.textContent;
        onchangeProvince();
      }
      provinceSearchInput.value = "";
      clearFilter("province-option");
      overlay.classList.add("hidden");
      provinceSelect.classList.remove("active");
    }
  });

  districtSelect.addEventListener("click", function (e) {
    const option = e.target.closest(".district-option");
    if (option) {
      if (myDistrict.textContent != option.dataset.value) {
        myDistrict.textContent = option.dataset.value;
        myDistrict.value = option.textContent;
        onchangeCity();
      }
      districtSearchInput.value = "";
      clearFilter("district-option");
      overlay.classList.add("hidden");
      districtSelect.classList.remove("active");
    }
  });
  subdistrictSelect.addEventListener("click", function (e) {
    const option = e.target.closest(".subdistrict-option");
    if (option) {
      if (mySubdistrict.textContent != option.dataset.value) {
        mySubdistrict.textContent = option.dataset.value;
        mySubdistrict.value = option.textContent;
        onchangeDistrict();
      }
      subdistrictSearchInput.value = "";
      clearFilter("subdistrict-option");
      overlay.classList.add("hidden");
      subdistrictSelect.classList.remove("active");
    }
  });
});

function editProfile(
  province_code = false,
  province_name = false,
  district = false,
  subdistrict = false,
  zip = false
) {
  document.getElementById("editBtn").style.display = "none";
  document.getElementById("profileTable").style.display = "none";
  document.getElementById("profileInfoMode").style.display = "none";
  document.getElementById("profileEditMode").style.display = "block";
  document.getElementById("saveBtn").style.display = "inline-block";
  document.getElementById("profileEditTable").style.display = "block";
  document.getElementById("opacityAvatar").style.display = "block";
  document.getElementById("profileCamera").style.display = "inline";
  $('input[class="file-upload"]').removeAttr("disabled");
  var settings = {
    url: "https://apishopify.gqsize.com/supara/get_province",
    method: "GET",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
  };
  $.ajax(settings).done(function (response) {
    const province_selection = document.getElementById("provinceSelect");
    for (let i = 0; i < response.length; i++) {
      var iDiv = document.createElement("div");
      iDiv.className = "province-option";
      iDiv.setAttribute("data-value", response[i].code);
      if (language_code == "th") {
        iDiv.innerText = response[i].name;
      } else {
        iDiv.innerText = response[i].en_name;
      }
      province_selection.appendChild(iDiv);
    }
    if (province_code != false) {
      document.getElementById("myProvince").value = province_name;
      document.getElementById("myProvince").textContent = province_code;
      onchangeProvince(province_code, district, subdistrict, zip);
    } else {
      if (language_code == "th") {
        document.getElementById("myProvince").value = "จังหวัด";
        document.getElementById("myDistrict").value = "เขต/อำเภอ";
        document.getElementById("mySubdistrict").value = "แขวง/ตำบล";
      }
      else {
        document.getElementById("myProvince").value = "Province";
        document.getElementById("myDistrict").value = "District";
        document.getElementById("mySubdistrict").value = "Sub district";
      }
      document.getElementById("myProvince").textContent = "";
      document.getElementById("myDistrict").textContent = "";
      document.getElementById("mySubdistrict").textContent = "";
      document.getElementById("ipostcode").value = "0";
    }
  });
}

function saveProfile(customer_id, address_id) {
  var email = document.getElementById("email").value;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailPattern.test(email) == false) {
    alert("Invalid email!");
  } else {
    document.getElementById("saveBtn").innerText = "";
    document.getElementById("saveBtn").disabled = true;
    document.getElementById("saveBtn").classList.add("spin");
    $('input[class="file-upload"]').attr("disabled", "disabled");
    var name = document.getElementById("fname").value;
    var lname = '';
    var phone = "";
    var dob = document.getElementById("idob").value;
    var address = document.getElementById("iaddress").value;
    var province_code = document.getElementById("myProvince").textContent;
    var district_code = document.getElementById("myDistrict").textContent;
    var subdistrict_code = document.getElementById("mySubdistrict").textContent;
    var zip = document.getElementById("ipostcode").value;
    var radios = document.getElementsByName("Cgender");
    var gender = "";
    var avatar_data = document.getElementById("profilePic").src;

    var current_first_name = document.getElementById("profileName").textContent;
    // var current_last_name = document.getElementById("profileLName").textContent;
    var current_phone = document.getElementById("profilePhone").textContent;
    var current_email = document.getElementById("profileEmail").textContent;

    if (document.getElementById("phone").value != "") {
      phone =
        $(".iti__selected-dial-code")[0].innerText +
        $("#phone").val().replace(/ /g, "");
    }

    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        gender = radios[i].value;
        break;
      }
    }

    var body = {
      customer_id: customer_id,
      address_id: address_id,
      first_name: name,
      last_name: lname,
      phone: phone,
      email: email,
      address1: address,
      gender: gender,
      avatar_data: avatar_data,
      dob: dob,
      current_first_name: current_first_name,
      current_last_name: current_last_name,
      current_phone: current_phone,
      current_email: current_email,
      language_code: language_code,
    };
    if (
      province_code != "0" &&
      district_code != "0" &&
      subdistrict_code != "0" &&
      zip != ""
    ) {
      body.province_code = province_code;
      body.district_code = district_code;
      body.subdistrict_code = subdistrict_code;
      body.zip = zip;
    }

    fetch("https://apishopify.gqsize.com/supara/update_my_account", {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "success") {
          if (language_code == "th") {
            alert("อัปเดตสำเร็จ!");
          } else {
            alert("Update successful");
          }
          window.location.reload();
        }
        if (data.status == "fail") {
          if (language_code == "th") {
            alert("อัปเดตล้มเหลว!");
          } else {
            alert("Update failed");
          }
          window.location.reload();
        }
        if (data.status == "phone-fail") {
          if (language_code == "th") {
            alert("หมายเลขโทรศัพท์ไม่ถูกต้อง!");
          } else {
            alert("Invalid phone number");
          }
          window.location.reload();
        }
      })
      .catch((error) => console.log("error", error));
  }
}

function onchangeProvince(
  province_code = false,
  district = false,
  subdistrict = false,
  zip = false
) {
  if (province_code == false) {
    var province_code = document.getElementById("myProvince").textContent;
  }
  var settings = {
    url: "https://apishopify.gqsize.com/supara/onchange_province",
    method: "GET",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      province_code: province_code,
    },
  };
  $.ajax(settings).done(function (response) {
    const district_selection = document.getElementById("districtOptions");
    districtOptions.innerHTML ='';
    for (let i = 0; i < response.length; i++) {
      var iDiv = document.createElement("div");
      iDiv.className = "district-option";
      iDiv.setAttribute("data-value", response[i].code);
      if (language_code == "th") {
        iDiv.innerText = response[i].name;
      } else {
        iDiv.innerText = response[i].en_name;
      }
      districtOptions.appendChild(iDiv);
      if (response[i].en_name == district || response[i].name == district) {
        if (language_code == "th") {
          document.getElementById("myDistrict").value = response[i].name;
        } else {
          document.getElementById("myDistrict").value = response[i].en_name;
        }
        document.getElementById("myDistrict").textContent = response[i].code;
      }
    }
    if (district != false) {
      onchangeCity(
        document.getElementById("myDistrict").textContent,
        subdistrict,
        zip
      );
    } else {
      if (language_code == "th") {
        document.getElementById("myDistrict").value = "เขต/อำเภอ";
        document.getElementById("mySubdistrict").value = "แขวง/ตำบล";
      }
      else {
        document.getElementById("myDistrict").value = "District";
        document.getElementById("mySubdistrict").value = "Sub district";
      }
      document.getElementById("myDistrict").textContent = "";
      document.getElementById("mySubdistrict").textContent = "";
      document.getElementById("ipostcode").value = "";
    }
  });
}

function onchangeCity(district_code = false, subdistrict = false, zip = false) {
  if (district_code == false) {
    var district_code = document.getElementById("myDistrict").textContent;
  }
  var settings = {
    url: "https://apishopify.gqsize.com/supara/onchange_city",
    method: "GET",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      city_code: district_code,
    },
  };
  $.ajax(settings).done(function (response) {
    const subdistrict_option = document.getElementById("subdistrictOptions");
    subdistrict_option.innerHTML ='';
    for (let i = 0; i < response.length; i++) {
      var iDiv = document.createElement("div");
      iDiv.className = "subdistrict-option";
      iDiv.setAttribute("data-value", response[i].code);
      if (language_code == "th") {
        iDiv.innerText = response[i].name;
      } else {
        iDiv.innerText = response[i].en_name;
      }
      subdistrict_option.appendChild(iDiv);
      if (response[i].en_name == subdistrict || response[i].name == subdistrict) {
        if (language_code == "th") {
          document.getElementById("mySubdistrict").value = response[i].name;
        } else {
          document.getElementById("mySubdistrict").value = response[i].en_name;
        }
        document.getElementById("mySubdistrict").textContent = response[i].code;
      }
    }
    if (subdistrict != false) {
      onchangeDistrict(zip);
    } else {
      if (language_code == "th") {
        document.getElementById("mySubdistrict").value = "แขวง/ตำบล";
      }
      else {
        document.getElementById("mySubdistrict").value = "Sub district";
      }
      document.getElementById("mySubdistrict").textContent = "";
      document.getElementById("ipostcode").value = "";
    }
  });
}

function onchangeDistrict(zip = false) {
  if (zip != false) {
    document.getElementById("ipostcode").value = zip;
  } else {
    subdistrict_code = document.getElementById("mySubdistrict").textContent;
    var settings = {
      url: "https://apishopify.gqsize.com/supara/onchange_subdistrict",
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        subdistrict_code: subdistrict_code,
      },
    };
    $.ajax(settings).done(function (response) {
      document.getElementById("ipostcode").value = response.postal_code;
    });
  }
}

$(document).ready(function () {
  if ($(window).width() <= 768) {
    $(".page-account .sidebar-main .sidebar-section").click(function () {
      $(this).toggleClass("open-tab");
      $(this).next().slideToggle("slow");
    });
  }
  var modal = $(".central.rte .modal");
  var overlay = $(".central.rte .overlay");
  const closeModal = function () {
    modal.addClass("hidden");
    overlay.addClass("hidden");
  };
  overlay.click(closeModal);
  $(".sidebar-main .cancel-logout-button").click(closeModal);
  // $(".close-line-popup").click(closeModal);

  function openPopup(popuplink) {
    popuplink.nextAll(".overlay,.modal").removeClass("hidden");
  }
  // open modal event
  $(".tabcontent .request-tax-btn").click(function () {
    openPopup($(this));
  });
  $(".sidebar-main .log-out").click(function () {
    openPopup($(this));
  });
  // $(".line-btn").click(function () {
  //   openPopup($(this));
  // });
});
